/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import _ from 'lodash';

import CMDMap from './CMDMap';

class Keypad extends Component {
  static defaultProps = {
    cmdmap: {},
  };

  handleKeyPress = (e) => {
    const value = $(e.target).closest('button').val();

    if (_.isUndefined(value)) {
      return;
    }

    if (CMDMap[value]) {
      this.props.onKeyPressCmd(CMDMap[value]);
    } else {
      this.props.onKeyPressWrite(value);
    }
  };

  render() {
    const classes = this.props.className || '';

    return (
      <div className={`keypad ${classes}`} onClick={this.handleKeyPress}>
        {this.props.children}
      </div>
    );
  }
}

export default Keypad;
